import React from "react";

function Fidelizacao() {
  return (
    <div className="home">
      <iframe
        title="Auto"
        class="video"
        widht="100%"
        height="100%"
        src="https://app.powerbi.com/reportEmbed?reportId=ef6f65fc-69e2-4d0f-9132-c6468d07373c&autoAuth=true&ctid=f88c7305-11d1-4b34-a8a0-da6536019e31"
        marginheight="0"
        marginwidth="0"
        scrolling="0"
        frameborder="0"
        allowFullScreen="true"
      ></iframe>
    </div>
  );
}

export default Fidelizacao;
